// extracted by mini-css-extract-plugin
export default {"block":"Topevents_block__MCiAO","ul":"Topevents_ul__gxVDe"};